import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Navigate, RouteProps } from 'react-router-dom';
import ContentManager from '../../components/Content/AppContent';
import { StoreState } from '../../store/createStore';

import { frontendNotification } from '../../components/Notification';
import { UrlPaths } from '../../enums/urlPaths.enum';
import { logoutRequest } from '../../store/modules/auth/actions';

interface Props {
  withNavBar?: boolean;
  component: React.ComponentType;
}

type PrivateRouteProps = Props & RouteProps;

const PrivateRoute: React.FC<PrivateRouteProps> = ({ withNavBar = true, component: Component }) => {
  const { isSignin, user, expirationDate } = useSelector((state: StoreState) => state.auth);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  if (isSignin && (expirationDate as number) < Date.now()) {
    frontendNotification({
      message: t('sessionExpired'),
      type: 'warning',
    });
    dispatch(logoutRequest());
  }

  if (isSignin && user) {
    return user.is_superadmin ? (
      <ContentManager permissionProfile="superadmin" Component={Component} navbar={withNavBar} />
    ) : (
      <ContentManager Component={Component as any} navbar={withNavBar} />
    );
  }

  return <Navigate to={UrlPaths.LOGIN} />;
};

PrivateRoute.defaultProps = {
  withNavBar: true,
};

export default PrivateRoute;
